import { brand, navLinks } from "@/mocks/chigua";

const contactItems = [
  { icon: "ri-mail-line", label: "编辑部邮箱", value: "editor@chiguaheiwu.com", href: "mailto:editor@chiguaheiwu.com" },
  { icon: "ri-customer-service-2-line", label: "投稿与线索", value: "tips@chiguaheiwu.com", href: "mailto:tips@chiguaheiwu.com" },
  { icon: "ri-community-line", label: "合作洽谈", value: "bd@chiguaheiwu.com", href: "mailto:bd@chiguaheiwu.com" },
];

function Footer() {
  return (
    <footer className="relative border-t border-background-800 bg-background-900/60">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#home" className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-moon-clear-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-xl font-bold text-foreground-50">{brand.name}</span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-500">
              {brand.slogan} —— {brand.desc}
            </p>
            <div className="mt-6 flex items-center gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill", "ri-youtube-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#subscribe"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-foreground-300 transition-colors hover:border-accent-500/50 hover:text-accent-300"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <nav className="lg:col-span-3" aria-label="页脚导航">
            <h4 className="font-serif text-base font-semibold text-foreground-100">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <a href={l.href} className="text-sm text-foreground-500 transition-colors hover:text-primary-300">
                    {l.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-4">
            <h4 className="font-serif text-base font-semibold text-foreground-100">联系我们</h4>
            <ul className="mt-4 space-y-3">
              {contactItems.map((c) => (
                <li key={c.label}>
                  <a
                    href={c.href}
                    className="flex items-start gap-3 text-sm text-foreground-500 transition-colors hover:text-accent-300"
                  >
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center">
                      <i className={`${c.icon} text-accent-400`} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block text-foreground-400">{c.label}</span>
                      {c.value}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-background-800 py-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} {brand.name} · 专注把娱乐与大众热点背后的门道讲清。保留所有权利。
          </p>
          <p className="flex items-center gap-2 text-xs text-foreground-600">
            <i className="ri-lock-line text-accent-400" aria-hidden="true"></i>
            内容基于公开信息整理，转载需注明出处
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;